import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const REGISTERED_AGENT_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.registeredAgent.buyBox.bulletPoint1' },
          { title: 'productPage.registeredAgent.buyBox.bulletPoint2' },
          { title: 'productPage.registeredAgent.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.registeredAgent.buyBox.productName',
        note: 'productPage.registeredAgent.buyBox.subCopy',
        interactService: {
          service: 'registered_agent',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/reading-documents-home.png',
      alt: 'productPage.registeredAgent.heroPicture.altText',
    },
    headline: 'productPage.registeredAgent.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    pill: {
      text: 'productPage.registeredAgent.page.headlinePill',
      bgcolor: 'background.red.light',
    },
    subheader: 'productPage.registeredAgent.page.subheader',
  },
  benefit: {
    title: 'productPage.registeredAgent.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.registeredAgent.valueProp.propTitle1',
        description: 'productPage.registeredAgent.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/securityrounded.svg',
        title: 'productPage.registeredAgent.valueProp.propTitle2',
        description: 'productPage.registeredAgent.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/inboxrounded.svg',
        title: 'productPage.registeredAgent.valueProp.propTitle3',
        description: 'productPage.registeredAgent.valueProp.shortCopy3',
      },
      {
        icon: '/s2/material-icons/locationonrounded.svg',
        title: 'productPage.registeredAgent.valueProp.propTitle4',
        description: 'productPage.registeredAgent.valueProp.shortCopy4',
      },
      {
        icon: '/s2/material-icons/strikethroughsrounded.svg',
        title: 'productPage.registeredAgent.valueProp.propTitle5',
        description: 'productPage.registeredAgent.valueProp.shortCopy5',
      },
      {
        icon: '/s2/material-icons/supportagentrounded.svg',
        title: 'productPage.registeredAgent.valueProp.propTitle6',
        description: 'productPage.registeredAgent.valueProp.shortCopy6',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/shieldrounded.svg',
    title: 'productPage.registeredAgent.topFeature.title',
    subheader: 'productPage.registeredAgent.topFeature.subheader',
    video: 'y8guj357t9',
    alt: 'productPage.registeredAgent.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.registeredAgent.howItWorks.title',
    items: [
      {
        title: 'productPage.registeredAgent.howItWorks.step1',
        description: 'productPage.registeredAgent.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.registeredAgent.howItWorks.step2',
        description: 'productPage.registeredAgent.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.registeredAgent.howItWorks.step3',
        description: 'productPage.registeredAgent.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/review-laptop-smiling.png',
    alt: 'productPage.registeredAgent.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.registeredAgent.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.registeredAgent.frequentlyAskedQuestions.faq1',
        answer: 'productPage.registeredAgent.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.registeredAgent.frequentlyAskedQuestions.faq2',
        answer: 'productPage.registeredAgent.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.registeredAgent.frequentlyAskedQuestions.faq3',
        answer: 'productPage.registeredAgent.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.registeredAgent.frequentlyAskedQuestions.faq4',
        answer: 'productPage.registeredAgent.frequentlyAskedQuestions.faqAnswer4',
      },
      {
        question: 'productPage.registeredAgent.frequentlyAskedQuestions.faq5',
        answer: 'productPage.registeredAgent.frequentlyAskedQuestions.faqAnswer5',
      },
    ],
  },
  assistance: {
    title: 'productPage.registeredAgent.needAssistance.title',
    getInTouch: 'productPage.registeredAgent.needAssistance.getInTouch',
    actions: 'productPage.registeredAgent.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.registeredAgent.buyBox.buttonLabel',
    }),
};
